<template>
    <div class="remotelink-contanier">
        <Dropdown trigger="click"
                  placement="bottom-end"
                  :transfer="true"
                  @on-click="openRemoteLink"
                  @on-visible-change="visibleChange">
            <!-- :transfer="entry === 'list'" -->
            <!-- <Button v-if="entry !== 'list'"
                    :disabled="tooltipsMap['远程连接'].disabled || isNoPer || remotePatterns.length === 0"
                    size="small">
                <Icon class="rc-va-middle"
                      type="md-desktop" />
                <span class="rc-va-middle">{{$t('远程连接')}}</span>
                <Icon type="ios-arrow-down"></Icon>
            </Button> -->
            <!-- v-else -->
            <span>
                <a href="javascript:void(0)"
                   class="link"
                   :class="(!isNoPer && remotePatterns.length > 0)?'':'disabled'">
                    {{$i18n.t('远程连接')}}
                    <Icon type="md-arrow-dropdown" />
                </a>
                <span></span>
            </span>
            <DropdownMenu slot="list"
                          v-if="!isNoPer && remotePatterns.length > 0">
                <DropdownItem v-for="item in remotePatterns"
                              :key="item"
                              :name="item">{{$t(item)}}</DropdownItem>
            </DropdownMenu>
        </Dropdown>
        <remotelinkoper :data="info"
                        :type="type"
                        ref="remotelinkoper"></remotelinkoper>
    </div>
</template>

<script>
import remotelinkoper from './remotelinkoper'
// import { mgtConstant } from '@/service/constant'
export default {
    name: 'paramConfig',
    props: ['info', 'isBareMetal'], // 'entry',
    components: {
        remotelinkoper
    },
    data () {
        return {
            // tooltipsMap: mgtConstant.tooltipsMap,
            remotePatterns: [],
            type: 'webSSH',
            isNoPer: false
        }
    },
    created () {
        this.visibleChange()
    },
    // watch: {
    //     info (val) {
    //         this.info = val
    //         this.init()
    //     }
    // },
    methods: {
        // isNoRemoteOper () {
        //     return this.info.lockStatus === 'locked' || !(this.info.status === 'running' || this.info.status === 'failure') ||
        //     this.isNoPer({click: 'remoteLink'}) || this.isNoPer
        // },
        visibleChange (visible) {
            this.init()
            // 判断远程链接权限
            this.isNoPer = this.info.lockStatus === 'locked' || !(this.info.status === 'running' || this.info.status === 'failure')
        },
        init () {
            let type = ''
            const remotePatterns = []
            switch (this.info.cloudEnvType) {
                case 'VMware':
                    type = 'VMware'
                    break
                case 'Aliyun':
                    type = '阿里云'
                    break
                case 'OpenStack':
                case 'OpenStack-Admin':
                case 'ESCloud':
                case 'ESCloud-Admin':
                case 'CloudOS':
                case 'Nine9Cloud':
                case 'Nine9Cloud-Admin':
                    type = this.info.cloudEnvName
                    break
            }
            if (type === 'VMware') {
                // 权限控制
                this.hasPermission('MB0234') && remotePatterns.push(
                    `通过${type} Remote Console访问`
                )
                remotePatterns.push(
                    `通过${type} Web控制台访问`
                )
            } else {
                type && !this.isBareMetal && remotePatterns.push(
                    '通过管理终端访问'
                )
            }
            if (this.info.osCategory) {
                if (this.info.osCategory.toLowerCase() === 'windows') {
                    remotePatterns.push(
                        '通过WebRDP访问'
                    )
                } else {
                    remotePatterns.push(
                        '通过WebSSH访问'
                    )
                }
            }
            this.remotePatterns = remotePatterns
        },
        openRemoteLink (name) {
            // 检验是否有通过它远程连接的权限
            name = this.remotePatterns.find(item => name === item) || this.remotePatterns[0]
            switch (name) {
                case '通过WebSSH访问':
                    this.type = 'WebSSH'
                    break
                default:
                    this.type = 'else'
                    break
            }
            this.info.operType = name
            this.$refs.remotelinkoper.openModal()
        }
    }
}
</script>

<style lang="less">
.remotelink-contanier {
    padding-left: 3px;
    margin-left: 1px;
    display: inline-block;
    .disabled {
        color: #ccc !important;
        cursor: not-allowed !important;
    }
}
</style>
